export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-2 h-2 rounded-full bg-teal-500"></div>
              <span className="text-xs font-semibold text-teal-500 uppercase tracking-wider">
                About Us
              </span>
            </div>
            
            <h3 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
              Protecting Privacy<br />Since Day One
            </h3>
            
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                At <strong>SLOZNA BRACA</strong>, we believe that online privacy is a fundamental right. Based in Split, Croatia, we've dedicated ourselves to developing cutting-edge VPN technology that keeps your digital life secure and private.
              </p>
              <p>
                Our mission is simple: provide enterprise-grade security solutions that are accessible to everyone. Whether you're browsing from home, working remotely, or traveling abroad, our VPN ensures your data remains encrypted and your identity protected.
              </p>
              <p>
                We combine advanced encryption protocols with a global network of high-speed servers to deliver uncompromising security without sacrificing performance. Your trust is our priority, and we're committed to maintaining the highest standards of privacy protection.
              </p>
              <p>
                Join thousands of users worldwide who trust SLOZNA BRACA to safeguard their digital freedom. Experience the peace of mind that comes with knowing your online activities are truly private and secure.
              </p>
            </div>
          </div>

          {/* Right Decorative Area */}
          <div className="relative h-[600px] rounded-3xl overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/bdd9906c8a13b6165e7f2fea02d01378.jpg"
              alt="Digital Security Illustration"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-teal-500/10 to-cyan-500/10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
